/* eslint-disable import/newline-after-import -- bs*/
/* Variables */
import './tokens/animations.css';
import './tokens/blurs.css';
import './tokens/border.css';
import './tokens/breakpoints.css';
import './tokens/colors.css';
import './tokens/colors-aliases.css';
import './tokens/fonts.css';
import './tokens/rounding.css';
import './tokens/shadows.css';
import './tokens/sizes.css';
import './tokens/z-index.css';
/* Import Font - for now can be here, once we figure out proper variable injection order
we should move that on top and set font-weight to the proper variable  */
import './fonts/AeonikFont.css';
import './fonts/JetBrainsMonoFont.css';
/* Reset */
import './reset/index.css';
/* Component Related Variables */
import './tokens/inputs.css';
import './tokens/scrollbar.css';
/* Common styles */
import './common/scrollbar.css';
/* eslint-enable import/newline-after-import */
